// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "exchangeRate.proto" (package "currency", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message currency.ExchangeRate
 */
export interface ExchangeRate {
    /**
     * @generated from protobuf field: uint32 currency_a = 1
     */
    currencyA: number;
    /**
     * @generated from protobuf field: uint32 currency_b = 2
     */
    currencyB: number;
    /**
     * @generated from protobuf field: double rate = 3
     */
    rate: number;
    /**
     * @generated from protobuf field: string date = 4
     */
    date: string;
}
/**
 * @generated from protobuf message currency.GetAllExchangeRateRequest
 */
export interface GetAllExchangeRateRequest {
}
/**
 * @generated from protobuf message currency.GetAllExchangeRateResponse
 */
export interface GetAllExchangeRateResponse {
    /**
     * @generated from protobuf field: repeated currency.ExchangeRate rates = 1
     */
    rates: ExchangeRate[];
}
/**
 * @generated from protobuf message currency.CreateExchangeRateRequest
 */
export interface CreateExchangeRateRequest {
    /**
     * @generated from protobuf field: uint32 currency_a = 1
     */
    currencyA: number;
    /**
     * @generated from protobuf field: uint32 currency_b = 2
     */
    currencyB: number;
    /**
     * @generated from protobuf field: double rate = 3
     */
    rate: number;
    /**
     * @generated from protobuf field: string date = 4
     */
    date: string;
}
/**
 * @generated from protobuf message currency.CreateExchangeRateResponse
 */
export interface CreateExchangeRateResponse {
}
/**
 * @generated from protobuf message currency.UpdateExchangeRateFields
 */
export interface UpdateExchangeRateFields {
    /**
     * @generated from protobuf field: double rate = 3
     */
    rate: number;
}
/**
 * @generated from protobuf message currency.UpdateExchangeRateRequest
 */
export interface UpdateExchangeRateRequest {
    /**
     * @generated from protobuf field: uint32 currency_a = 1
     */
    currencyA: number;
    /**
     * @generated from protobuf field: uint32 currency_b = 2
     */
    currencyB: number;
    /**
     * @generated from protobuf field: string date = 3
     */
    date: string;
    /**
     * @generated from protobuf field: currency.UpdateExchangeRateFields fields = 4
     */
    fields?: UpdateExchangeRateFields;
}
/**
 * @generated from protobuf message currency.UpdateExchangeRateResponse
 */
export interface UpdateExchangeRateResponse {
}
/**
 * @generated from protobuf message currency.DeleteExchangeRateRequest
 */
export interface DeleteExchangeRateRequest {
    /**
     * @generated from protobuf field: uint32 currency_a = 1
     */
    currencyA: number;
    /**
     * @generated from protobuf field: uint32 currency_b = 2
     */
    currencyB: number;
    /**
     * @generated from protobuf field: string date = 3
     */
    date: string;
}
/**
 * @generated from protobuf message currency.DeleteExchangeRateResponse
 */
export interface DeleteExchangeRateResponse {
}
/**
 * @generated from protobuf message currency.TestGetCurrencyRateRequest
 */
export interface TestGetCurrencyRateRequest {
    /**
     * @generated from protobuf field: string script = 1
     */
    script: string;
}
/**
 * @generated from protobuf message currency.TestGetCurrencyRateResponse
 */
export interface TestGetCurrencyRateResponse {
    /**
     * @generated from protobuf field: string response = 1
     */
    response: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class ExchangeRate$Type extends MessageType<ExchangeRate> {
    constructor() {
        super("currency.ExchangeRate", [
            { no: 1, name: "currency_a", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "currency_b", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExchangeRate>): ExchangeRate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.currencyA = 0;
        message.currencyB = 0;
        message.rate = 0;
        message.date = "";
        if (value !== undefined)
            reflectionMergePartial<ExchangeRate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExchangeRate): ExchangeRate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 currency_a */ 1:
                    message.currencyA = reader.uint32();
                    break;
                case /* uint32 currency_b */ 2:
                    message.currencyB = reader.uint32();
                    break;
                case /* double rate */ 3:
                    message.rate = reader.double();
                    break;
                case /* string date */ 4:
                    message.date = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExchangeRate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 currency_a = 1; */
        if (message.currencyA !== 0)
            writer.tag(1, WireType.Varint).uint32(message.currencyA);
        /* uint32 currency_b = 2; */
        if (message.currencyB !== 0)
            writer.tag(2, WireType.Varint).uint32(message.currencyB);
        /* double rate = 3; */
        if (message.rate !== 0)
            writer.tag(3, WireType.Bit64).double(message.rate);
        /* string date = 4; */
        if (message.date !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.date);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.ExchangeRate
 */
export const ExchangeRate = new ExchangeRate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllExchangeRateRequest$Type extends MessageType<GetAllExchangeRateRequest> {
    constructor() {
        super("currency.GetAllExchangeRateRequest", []);
    }
    create(value?: PartialMessage<GetAllExchangeRateRequest>): GetAllExchangeRateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAllExchangeRateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllExchangeRateRequest): GetAllExchangeRateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllExchangeRateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.GetAllExchangeRateRequest
 */
export const GetAllExchangeRateRequest = new GetAllExchangeRateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllExchangeRateResponse$Type extends MessageType<GetAllExchangeRateResponse> {
    constructor() {
        super("currency.GetAllExchangeRateResponse", [
            { no: 1, name: "rates", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExchangeRate }
        ]);
    }
    create(value?: PartialMessage<GetAllExchangeRateResponse>): GetAllExchangeRateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.rates = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllExchangeRateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllExchangeRateResponse): GetAllExchangeRateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated currency.ExchangeRate rates */ 1:
                    message.rates.push(ExchangeRate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllExchangeRateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated currency.ExchangeRate rates = 1; */
        for (let i = 0; i < message.rates.length; i++)
            ExchangeRate.internalBinaryWrite(message.rates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.GetAllExchangeRateResponse
 */
export const GetAllExchangeRateResponse = new GetAllExchangeRateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExchangeRateRequest$Type extends MessageType<CreateExchangeRateRequest> {
    constructor() {
        super("currency.CreateExchangeRateRequest", [
            { no: 1, name: "currency_a", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "currency_b", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateExchangeRateRequest>): CreateExchangeRateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.currencyA = 0;
        message.currencyB = 0;
        message.rate = 0;
        message.date = "";
        if (value !== undefined)
            reflectionMergePartial<CreateExchangeRateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExchangeRateRequest): CreateExchangeRateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 currency_a */ 1:
                    message.currencyA = reader.uint32();
                    break;
                case /* uint32 currency_b */ 2:
                    message.currencyB = reader.uint32();
                    break;
                case /* double rate */ 3:
                    message.rate = reader.double();
                    break;
                case /* string date */ 4:
                    message.date = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateExchangeRateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 currency_a = 1; */
        if (message.currencyA !== 0)
            writer.tag(1, WireType.Varint).uint32(message.currencyA);
        /* uint32 currency_b = 2; */
        if (message.currencyB !== 0)
            writer.tag(2, WireType.Varint).uint32(message.currencyB);
        /* double rate = 3; */
        if (message.rate !== 0)
            writer.tag(3, WireType.Bit64).double(message.rate);
        /* string date = 4; */
        if (message.date !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.date);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.CreateExchangeRateRequest
 */
export const CreateExchangeRateRequest = new CreateExchangeRateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateExchangeRateResponse$Type extends MessageType<CreateExchangeRateResponse> {
    constructor() {
        super("currency.CreateExchangeRateResponse", []);
    }
    create(value?: PartialMessage<CreateExchangeRateResponse>): CreateExchangeRateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateExchangeRateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateExchangeRateResponse): CreateExchangeRateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateExchangeRateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.CreateExchangeRateResponse
 */
export const CreateExchangeRateResponse = new CreateExchangeRateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExchangeRateFields$Type extends MessageType<UpdateExchangeRateFields> {
    constructor() {
        super("currency.UpdateExchangeRateFields", [
            { no: 3, name: "rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateExchangeRateFields>): UpdateExchangeRateFields {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.rate = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateExchangeRateFields>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExchangeRateFields): UpdateExchangeRateFields {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double rate */ 3:
                    message.rate = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExchangeRateFields, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double rate = 3; */
        if (message.rate !== 0)
            writer.tag(3, WireType.Bit64).double(message.rate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.UpdateExchangeRateFields
 */
export const UpdateExchangeRateFields = new UpdateExchangeRateFields$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExchangeRateRequest$Type extends MessageType<UpdateExchangeRateRequest> {
    constructor() {
        super("currency.UpdateExchangeRateRequest", [
            { no: 1, name: "currency_a", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "currency_b", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "fields", kind: "message", T: () => UpdateExchangeRateFields }
        ]);
    }
    create(value?: PartialMessage<UpdateExchangeRateRequest>): UpdateExchangeRateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.currencyA = 0;
        message.currencyB = 0;
        message.date = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateExchangeRateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExchangeRateRequest): UpdateExchangeRateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 currency_a */ 1:
                    message.currencyA = reader.uint32();
                    break;
                case /* uint32 currency_b */ 2:
                    message.currencyB = reader.uint32();
                    break;
                case /* string date */ 3:
                    message.date = reader.string();
                    break;
                case /* currency.UpdateExchangeRateFields fields */ 4:
                    message.fields = UpdateExchangeRateFields.internalBinaryRead(reader, reader.uint32(), options, message.fields);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExchangeRateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 currency_a = 1; */
        if (message.currencyA !== 0)
            writer.tag(1, WireType.Varint).uint32(message.currencyA);
        /* uint32 currency_b = 2; */
        if (message.currencyB !== 0)
            writer.tag(2, WireType.Varint).uint32(message.currencyB);
        /* string date = 3; */
        if (message.date !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.date);
        /* currency.UpdateExchangeRateFields fields = 4; */
        if (message.fields)
            UpdateExchangeRateFields.internalBinaryWrite(message.fields, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.UpdateExchangeRateRequest
 */
export const UpdateExchangeRateRequest = new UpdateExchangeRateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateExchangeRateResponse$Type extends MessageType<UpdateExchangeRateResponse> {
    constructor() {
        super("currency.UpdateExchangeRateResponse", []);
    }
    create(value?: PartialMessage<UpdateExchangeRateResponse>): UpdateExchangeRateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateExchangeRateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateExchangeRateResponse): UpdateExchangeRateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateExchangeRateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.UpdateExchangeRateResponse
 */
export const UpdateExchangeRateResponse = new UpdateExchangeRateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteExchangeRateRequest$Type extends MessageType<DeleteExchangeRateRequest> {
    constructor() {
        super("currency.DeleteExchangeRateRequest", [
            { no: 1, name: "currency_a", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "currency_b", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteExchangeRateRequest>): DeleteExchangeRateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.currencyA = 0;
        message.currencyB = 0;
        message.date = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteExchangeRateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteExchangeRateRequest): DeleteExchangeRateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 currency_a */ 1:
                    message.currencyA = reader.uint32();
                    break;
                case /* uint32 currency_b */ 2:
                    message.currencyB = reader.uint32();
                    break;
                case /* string date */ 3:
                    message.date = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteExchangeRateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 currency_a = 1; */
        if (message.currencyA !== 0)
            writer.tag(1, WireType.Varint).uint32(message.currencyA);
        /* uint32 currency_b = 2; */
        if (message.currencyB !== 0)
            writer.tag(2, WireType.Varint).uint32(message.currencyB);
        /* string date = 3; */
        if (message.date !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.date);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.DeleteExchangeRateRequest
 */
export const DeleteExchangeRateRequest = new DeleteExchangeRateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteExchangeRateResponse$Type extends MessageType<DeleteExchangeRateResponse> {
    constructor() {
        super("currency.DeleteExchangeRateResponse", []);
    }
    create(value?: PartialMessage<DeleteExchangeRateResponse>): DeleteExchangeRateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteExchangeRateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteExchangeRateResponse): DeleteExchangeRateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteExchangeRateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.DeleteExchangeRateResponse
 */
export const DeleteExchangeRateResponse = new DeleteExchangeRateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestGetCurrencyRateRequest$Type extends MessageType<TestGetCurrencyRateRequest> {
    constructor() {
        super("currency.TestGetCurrencyRateRequest", [
            { no: 1, name: "script", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TestGetCurrencyRateRequest>): TestGetCurrencyRateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.script = "";
        if (value !== undefined)
            reflectionMergePartial<TestGetCurrencyRateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TestGetCurrencyRateRequest): TestGetCurrencyRateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string script */ 1:
                    message.script = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TestGetCurrencyRateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string script = 1; */
        if (message.script !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.script);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.TestGetCurrencyRateRequest
 */
export const TestGetCurrencyRateRequest = new TestGetCurrencyRateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestGetCurrencyRateResponse$Type extends MessageType<TestGetCurrencyRateResponse> {
    constructor() {
        super("currency.TestGetCurrencyRateResponse", [
            { no: 1, name: "response", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TestGetCurrencyRateResponse>): TestGetCurrencyRateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = "";
        if (value !== undefined)
            reflectionMergePartial<TestGetCurrencyRateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TestGetCurrencyRateResponse): TestGetCurrencyRateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string response */ 1:
                    message.response = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TestGetCurrencyRateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string response = 1; */
        if (message.response !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.response);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.TestGetCurrencyRateResponse
 */
export const TestGetCurrencyRateResponse = new TestGetCurrencyRateResponse$Type();
/**
 * @generated ServiceType for protobuf service currency.ExchangeRateService
 */
export const ExchangeRateService = new ServiceType("currency.ExchangeRateService", [
    { name: "GetAllExchangeRate", options: {}, I: GetAllExchangeRateRequest, O: GetAllExchangeRateResponse },
    { name: "CreateExchangeRate", options: {}, I: CreateExchangeRateRequest, O: CreateExchangeRateResponse },
    { name: "UpdateExchangeRate", options: {}, I: UpdateExchangeRateRequest, O: UpdateExchangeRateResponse },
    { name: "DeleteExchangeRate", options: {}, I: DeleteExchangeRateRequest, O: DeleteExchangeRateResponse },
    { name: "TestGetCurrencyRate", options: {}, I: TestGetCurrencyRateRequest, O: TestGetCurrencyRateResponse }
]);
